import { Heart } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-black/10 dark:border-white/10 py-6">
      <div className="px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-black/60 dark:text-white/60">
          {/* Left Side */}
          <div className="flex items-center gap-2">
            <p>© {currentYear} TaskFlow.</p>
            <span className="hidden md:inline">Todos os direitos reservados.</span>
          </div>

          {/* Center */}
          <div className="flex items-center gap-1">
            <span>Feito com</span>
            <Heart className="h-4 w-4 text-red-500 fill-red-500" />
            <span>em Moçambique</span>
          </div>

          {/* Right Side */}
          <div className="flex items-center gap-6">
            <button className="hover:text-black dark:hover:text-white transition-colors">
              Privacidade
            </button>
            <button className="hover:text-black dark:hover:text-white transition-colors">
              Termos
            </button>
            <button className="hover:text-black dark:hover:text-white transition-colors">
              Suporte
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}